import { CreateSyndicateFormFieldValues } from './types';

export const FIELD_TO_VALUE_MAPPER = {
  syndicateName: 'Syndicate Name',
  description: 'Description',
  syndicateLogo: 'Syndicate Logo',
  coverImage: 'Cover Image',
  website: 'Website',
  totalInvestments: 'Total Investments',
  totalPortfolioValue: 'Total Portfolio Value',
  dealsInvestedLately: 'Deals Invested In The Last 12 Months',
  numberOfLimitedPartners: 'Number Of Lps',
  avgLpsInvestPerDeal: 'Average Lps Per Deal',
  followOnRate: 'Follow On Rate',
  bypassScreening: 'Bypass Screening',
  //members tab
  syndicateMembers: 'Syndicate Members',
  pastInvestments: 'Past Investments',
  //data room tab
  quickLinks: 'Quick Links',
  news: 'News'
} as { [x: string]: string };

export const FIELD_TO_TAB_MAPPER = {
  0: [
    'syndicateName',
    'description',
    'syndicateLogo',
    'coverImage',
    'website',
    'totalInvestments',
    'totalPortfolioValue',
    'dealsInvestedLately',
    'numberOfLimitedPartners',
    'avgLpsInvestPerDeal',
    'followOnRate',
    'bypassScreening'
  ],
  1: ['syndicateMembers', 'pastInvestments'],
  2: ['quickLinks', 'news'],
  3: []
} as { [x: string]: string[] };

export enum SYNDICATE_STATUS {
  Draft = 'Draft',
  InfinyteReview = 'InfinyteReview',
  Active = 'Active'
}

export const MODAL_TYPES = {
  error: 'errorModal',
  publish: 'publishModal'
};

export const createSyndicateFormDefaultValues: CreateSyndicateFormFieldValues =
  {
    id: '',
    action: '',
    currentStep: 0,
    syndicateName: '',
    syndicateCode: '',
    description: '',
    syndicateLogo: { file: undefined, path: '' },
    coverImage: { file: undefined, path: '' },
    website: '',
    bypassScreening: false,
    showTermsToLead: false,
    showTermsToLps: false,
    totalInvestments: '',
    totalPortfolioValue: '',
    dealsInvestedLately: '',
    numberOfLimitedPartners: '',
    avgLpsInvestPerDeal: '',
    followOnRate: '',
    //members
    syndicateMembers: [
      {
        id: '',
        syndicateLead: true,
        name: '',
        email: '',
        description: '',
        profileImage: { file: undefined, path: '' }
        // coverImage: { file: undefined, path: '' }
      }
    ],
    pastInvestments: [
      {
        id: '',
        companyName: '',
        industryTag: '',
        companyLogo: { file: undefined, path: '' },
        keywords: '',
        about: '',
        investedStage: '',
        investedSince: '',
        quickLinks: []
      }
    ],
    quickLinks: [],
    news: []
  };
